import { BaseClient } from '../base-client';
import type { CreateTenantInput, Tenant, UpdateTenantInput } from './types';

export class TenantsClient extends BaseClient {
  list(): Promise<{ tenants: Tenant[] }> {
    return this.request('/api/tenants');
  }

  get(id: string): Promise<{ tenant: Tenant | null }> {
    return this.request(`/api/tenants/${encodeURIComponent(id)}`);
  }

  create(input: CreateTenantInput): Promise<{ tenant: Tenant }> {
    return this.request('/api/tenants', { method: 'POST', body: input });
  }

  update(id: string, input: UpdateTenantInput): Promise<{ tenant: Tenant }> {
    return this.request(`/api/tenants/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: input,
    });
  }
}
